import React, { useState, useEffect } from 'react';
import {
  Grid,
  Menu,
  MenuItem,
  TextField,
  Typography,
  InputLabel,
  Box,
  Button,
  Card,
  Select,
  Icon,
  Input,
  Link,
} from '@mui/material';
import MKBox from "components/MKBox";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import Container from "@mui/material/Container";
import MKAvatar from "components/MKAvatar";
import MKButton from "components/MKButton";
import MKInput from 'components/MKInput';
import MKTypography from "components/MKTypography";
import profilePicture from "assets/images/bruce-mars.jpg";
import Profile from "pages/LandingPages/Author/sections/Profile";
import Posts from "pages/LandingPages/Author/sections/Posts";
import Contact from "pages/LandingPages/Author/sections/Contact";
import Footer from "pages/LandingPages/Author/sections/Footer";
import routes from "trainingCompanyEditRoutes";
import bgImage from "assets/images/trainer-profile.jpg";
import { useParams } from "react-router-dom";
import Logo from "assets/images/skill2.png";
import Breadcrumbs from "examples/Breadcrumbs";
import { LocationOn, AttachMoney, WindowSharp } from '@mui/icons-material';
import SimpleFooter from "examples/Footers/SimpleFooter";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Modal from "@mui/material/Modal";
import DatePicker from "react-multi-date-picker";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { getAllISOCodes, getAllInfoByISO } from 'iso-country-currency';
import FormControl from '@mui/material/FormControl';
import MKAlert from "components/MKAlert";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const LoadingOverlay = ({ loading, children }) => {
  return (
    <>
      {loading && (
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            filter: 'blur(5px)',
            pointerEvents: 'none',
          }}
          open={loading}
        >
          <Box
            sx={{
              position: "absolute",
              top: "0",
              left: "0",
              zIndex: "1",
              width: "100%",
              minHeight: "100vh",
              // display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              userSelect: 'none',
            }}
          >
            {children}
          </Box>
        </Backdrop>
      )}
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: (theme) => theme.zIndex.drawer + 2,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!loading && children}
    </>
  );
};

function CustomMultipleInput({ openCalendar, value }) {
  return (
    <div>
      <input type="hidden"
        onFocus={openCalendar}
        value={value}
        readOnly
      />
      <MKButton variant="gradient" color="info" size="small" style={{ marginLeft: "40px" }} onClick={openCalendar}>Select Dates</MKButton>
    </div>
  )
}

function Author() {
  const { trainingID } = useParams();
  const [trainingDetails, setTrainingDetails] = useState([]);
  const [bbdata, setbbData] = useState([]);
  const [trainingList, setTrainingList] = useState([]);
  const [submitCompleted, setSubmitCompleted] = useState(false);
  const [submitTrainerAcceptCompleted, setSubmitTrainerAcceptCompleted] = useState(false);
  const [submitStartDiscussionCompleted, setSubmitStartDiscussionCompleted] = useState(false);
  const [submitTrainingScheduleCompleted, setSubmitTrainingScheduleCompleted] = useState(false);
  const [submitStartTrainingCompleted, setSubmitStartTrainingCompleted] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [submitFeedbackCompleted, setSubmitFeedbackCompleted] = useState(false);
  const [submitPaymentCompleted, setSubmitPaymentCompleted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [trainerDetails, setTrainerDetails] = useState([]);
  const [selectedCurrencyCountry, setSelectedCurrencyCountry] = useState('');
  const [commercialsCurrency, setCommercialsCurrency] = useState("");
  const [commercialsLessThan4hrs, setCommercialsLessThan4hrs] = useState("");
  const [commercials4hrs, setCommercials4hrs] = useState("");
  const [commercials8hrs, setCommercials8hrs] = useState("");
  const [lastDeliveredDate, setLastDeliveredDate] = useState("");
  const [lastClient, setLastClient] = useState("");
  const [courseDuration, setCourseDuration] = useState("");
  const [trainingAvailableDate, setTrainingAvailableDate] = useState([]);
  const [callAvailableDate, setCallAvailableDate] = useState([]);
  const [trainingComment, settrainingComment] = useState("");
  const [userId, setUserId] = useState("");
  const [currency, setCurrency] = useState('');
  const [trainerProfile, setTrainerProfile] = useState("");
  const [selectedTrainingCompanyId, setSelectedTrainingCompanyId] = useState("");
  const [selectedTraining, setSelectedTraining] = useState(null);
  const [selectedTrainingName, setSelectedTrainingName] = useState("");
  const [selectedTrainingID, setSelectedTrainingID] = useState("");
  const [lab, setLab] = useState("");
  const [labCostPerParticipants, setLabCostPerParticipants] = useState("");
  const [serverCount, setServerCount] = useState("");
  const [typeOfServer, setTypeOfServer] = useState("");
  const [submitAcceptCompleted, setSubmitAcceptCompleted] = useState(false);
  const [maxRemainderCount, setMaxRemainderCount] = useState("");
  const [responseFromDB, setResponseFromDB] = useState("");
  const [loading, setLoading] = useState(false);
  const [trainingStartDate, setTrainingStartDate] = useState('');
  const [trainingEndDate, setTrainingEndDate] = useState('');
  const [finalizedCommercials, setFinalizedCommercials] = useState('');
  const [expectedPaymentDate, setExpectedPaymentDate] = useState('');
  const [expectedNewPaymentDate, setExpectedNewPaymentDate] = useState('');
  const [feedbackStatusAvailable, setFeedbackStatusAvailable] = useState(false);
  const [finalizedTrainingSchedule, setFinalizedTrainingSchedule] = useState('');
  const [finalizedTrainingTiming, setFinalizedTrainingTiming] = useState('');
  const [finalizedStartTime, setFinalizedStartTime] = useState('');
  const [finalizedEndTime, setFinalizedEndTime] = useState('');
  const [feedbackQuestions, setFeedbackQuestions] = useState([]);
  const [feedbackRating, setFeedbackRating] = useState(0);
  const [isFeedback1Interacted, setIsFeedback1Interacted] = useState(false);
  const [feedbackAnswer1, setFeedbackAnswer1] = useState("");
  const [isFeedback2Interacted, setIsFeedback2Interacted] = useState(false);
  const [feedbackAnswer2, setFeedbackAnswer2] = useState("");
  const [isFeedback3Interacted, setIsFeedback3Interacted] = useState(false);
  const [feedbackAnswer3, setFeedbackAnswer3] = useState("");
  const [isFeedback4Interacted, setIsFeedback4Interacted] = useState(false);
  const [feedbackAnswer4, setFeedbackAnswer4] = useState("");
  const [isFeedback5Interacted, setIsFeedback5Interacted] = useState(false);
  const [feedbackAnswer5, setFeedbackAnswer5] = useState("");
  const [isFeedback6Interacted, setIsFeedback6Interacted] = useState(false);
  const [feedbackAnswer6, setFeedbackAnswer6] = useState("");
  const [isFeedback7Interacted, setIsFeedback7Interacted] = useState(false);
  const [feedbackAnswer7, setFeedbackAnswer7] = useState("");
  const [isFeedback8Interacted, setIsFeedback8Interacted] = useState(false);
  const [feedbackAnswer8, setFeedbackAnswer8] = useState("");
  const [trainingCompanyProfileDetails, setTrainingCompanyProfileDetails] = useState([])

  useEffect(() => {
    let id = localStorage.getItem("userId");
    fetch(`${process.env.REACT_APP_API_URL}/api/training-companyprofile-filter/${id}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setTrainingCompanyProfileDetails(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  console.log("trainingCompanyProfileDetails", trainingCompanyProfileDetails);

  useEffect(() => {
    console.log("trainingID", trainingID);
    fetch(`${process.env.REACT_APP_API_URL}/api/applied-training-more-details/${trainingID}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setbbData(data);
          setTrainingDetails(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  console.log("trainingDetails", trainingDetails);
  console.log("data", bbdata);



  useEffect(() => {
    let id = localStorage.getItem("userId");
    setUserId(id);
    if (trainingDetails.appliedTrainerID) {
      fetch(`${process.env.REACT_APP_API_URL}/api/trainer-profile-list/${trainingDetails.appliedTrainerID}/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
          if (data.detail) {
          } else {
            setTrainerDetails(data);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [trainingDetails]);
  console.log("trainerDetails", trainerDetails);

  // const handleCountryCurrencyChange = (event) => {
  //   const selectedISO = event.target.value;
  //   setSelectedCurrencyCountry(selectedISO);

  //   const currencyInfo = getAllInfoByISO(selectedISO);
  //   setCurrency(`${currencyInfo.currency} (${currencyInfo.symbol})`);
  // };

  // console.log("currency",currency);

  const today = new Date().toISOString().split('T')[0];
  const handleLastDeliveredDateChange = (e) => {
    setLastDeliveredDate(e.target.value);
  };
  console.log("lastDeliveredDate", lastDeliveredDate);

  const handleTrainingAvailableChange = (selectedDates) => {
    const formattedDates = selectedDates.map((date) => {
      return date.format('YYYY-MM-DD');
    });

    setTrainingAvailableDate(formattedDates);
  };

  console.log("trainingAvailableDate", trainingAvailableDate);

  const handleCallAvailableDateChange = (selectedDates) => {
    const formattedDates = selectedDates.map((date) => {
      return date.format('YYYY-MM-DD');
    });

    setCallAvailableDate(formattedDates);
  };
  console.log("callAvailableDate", callAvailableDate);


  const handleTrainingProfileChange = (e) => {
    const selectedProfile = e.target.value;
    setTrainerProfile(selectedProfile);

    // Parse trainerDetails.trainingExperience as an array
    const experienceArray = JSON.parse(trainerDetails.trainingExperience.replace(/'/g, '"'));

    // Find the matching profile in the parsed array
    const selectedExperience = experienceArray.find(
      (experience) => experience.profileName === selectedProfile
    );

    // Update the commercials fields with the corresponding values
    if (selectedExperience) {
      setCommercialsLessThan4hrs(selectedExperience.forLessThan4hrs || "");
      setCommercials4hrs(selectedExperience.for4hrs || "");
      setCommercials8hrs(selectedExperience.for8hrs || "");
      setCommercialsCurrency(selectedExperience.commercialsCurrency || "");
      setLastDeliveredDate(selectedExperience.dateOfLastTraining || "");
      setLastClient(selectedExperience.clientDelivered || "");
      setSelectedCurrencyCountry(selectedExperience.selectedCommercialsCurrency || "");
      setCourseDuration(selectedExperience.trainingDuration || "");
    }
  };


  const onApplyClick = (training) => {
    let name = training.trainingName;
    let trainingId = training.id.toString();
    setSelectedTrainingName(name);
    setSelectedTrainingID(trainingId);
    let companyID = training.trainingCompanyUserID;
    setSelectedTrainingCompanyId(companyID);
    setShowModal(true);
  };
  console.log("selectedTrainingName", selectedTrainingName);
  console.log("selectedTrainingID", selectedTrainingID);
  console.log("selectedTrainingCompanyId", selectedTrainingCompanyId);

  const onCloseApplyClick = () => {
    setShowModal(false);
    setCommercialsLessThan4hrs("");
    setCommercials4hrs("");
    setCommercials8hrs("");
    setLab("");
    setServerCount("");
    setTypeOfServer("");
    setLabCostPerParticipants("");
    setTrainingAvailableDate("");
    setCallAvailableDate("");
    setCourseDuration("");
    setLastDeliveredDate("");
    setLastClient("");
    settrainingComment("");
    setTrainerProfile("");
    setSelectedCurrencyCountry("");
    setCurrency("");
  };

  const onSaveApplyClick = (e) => {
    const data = {
      appliedTrainerID: userId,
      selectedTrainingID: selectedTrainingID,
      selectedTrainingName: selectedTrainingName,
      trainingCompanyUserID: selectedTrainingCompanyId,
      tocURL: "aaa",
      currency: commercialsCurrency,
      commercialsForLessThan4hrs: commercialsLessThan4hrs,
      commercialsFor4hrs: commercials4hrs,
      commercialsFor8hrs: commercials8hrs,
      labsByTrainer: lab,
      serverCount: serverCount,
      typeOfServer: typeOfServer,
      labCostPerParticipants: labCostPerParticipants,
      availableDatesForTraining: trainingAvailableDate,
      availableDatesForCall: callAvailableDate,
      courseDurationHRS: courseDuration,
      recentLastDeliveredDate: lastDeliveredDate,
      recentLastDeliveredClient: lastClient,
      comments: trainingComment,
      applyTrainingStatus: "1",
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/apply-training/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitCompleted(true);
        } else {
          setSubmitCompleted(false);
          throw new Error("Profile is not created. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const onAgreeClick = (training) => {
    setLoading(true);
    console.log("111111111111111111", training);
    const data = {
      applyTrainingStatus: "2",
      previousStatus: "1",
      appliedTrainerID: training.appliedTrainerID,
      trainingCompanyUserID: training.trainingCompanyUserID,
      selectedTrainingID: training.selectedTrainingID,
      selectedTrainingName: training.trainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitTrainerAcceptCompleted(true);
          setLoading(false);
        } else {
          setSubmitTrainerAcceptCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const DialogProfileAcceptClose = () => {
    setSubmitAcceptCompleted(false);
    // window.location.href = "/app/trainingcompanydashboard";
    window.location.href = `/app/appliedtrainermoredetails/${trainingID}/`;
  };

  const onRemainderClick = (e) => {
    setLoading(true);
    setMaxRemainderCount(false);
    const data = {
      id: trainingID,
      premiumStatus: trainingDetails.premiumStatus,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/apply-training-reminder/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          setSubmitCompleted(false);
          throw new Error("Profile is not created. Something went wrong");
        }
      })
      .then((data) => {
        console.log("Response from backend:", data.message);
        if (data.message === "Remainder reached maximum for the day") {
          setResponseFromDB(data.message);
          setMaxRemainderCount(true);
          setLoading(false);
        } else if (data.message === "We have re-sent you a link to the company to accept your request") {
          setResponseFromDB(data.message);
          setSubmitCompleted(true);
          setLoading(false);
        } else {
          setResponseFromDB(data.message);
          setSubmitCompleted(false);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("Error:", error.message);
      });
  };

  // const onRemainderClick = (e) => {
  //   setMaxRemainderCount(false);
  //   const data = {
  //     id:trainingID,
  //   };
  //   console.log(JSON.stringify(data));
  //   fetch(`${process.env.REACT_APP_API_URL}/api/apply-training-reminder/`, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: "Bearer " + localStorage.getItem("token"),
  //     },
  //     body: JSON.stringify(data),

  //   })
  //     .then((response) => {
  //       if (response.ok) {
  //         console.log("aaaaaaaaaaa");
  //         setSubmitCompleted(true);
  //       } else {
  //         setSubmitCompleted(false);
  //         throw new Error("Profile is not created. Something went wrong");
  //       }
  //     })
  //     .then((data) => {
  //       console.log("Response from backend:", data.message);
  //       if(data.message === "Remainder reached maximum for the day"){
  //         setResponseFromDB(data.message); 
  //         setMaxRemainderCount(true);
  //       } else if(data.message === "We have re-sent you a link to the company to accept your request" ){
  //         setResponseFromDB(data.message); 
  //         setSubmitCompleted(true);
  //       } else {
  //         setResponseFromDB(data.message); 
  //         setSubmitCompleted(false);
  //       }     
  //     })
  //     .catch((error) => {
  //       console.log("oooooooooooooooo", error.message);
  //     });
  // };

  const onStartDiscussionClick = (trainer) => {
    setLoading(true);
    console.log("111111111111111111", trainer);
    const data = {
      applyTrainingStatus: "4",
      previousStatus: "3",
      appliedTrainerID: trainer.appliedTrainerID,
      trainingCompanyUserID: trainer.trainingCompanyUserID,
      selectedTrainingID: trainer.selectedTrainingID,
      selectedTrainingName: trainer.selectedTrainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitStartDiscussionCompleted(true);
          setLoading(false);
        } else {
          setSubmitStartDiscussionCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 30);
  const maxDateString = maxDate.toISOString().split('T')[0];

  const handleCountryCurrencyChange = (event) => {
    const selectedISO = event.target.value;
    setSelectedCurrencyCountry(selectedISO);

    const currencyInfo = getAllInfoByISO(selectedISO);
    setCurrency(`${currencyInfo.currency} (${currencyInfo.symbol})`);
  };

  console.log("selectedCurrencyCountry", selectedCurrencyCountry);

  const handleTrainingStartDateChange = (event) => {
    setTrainingStartDate(event.target.value);
  };

  const handleTrainingEndDateChange = (event) => {
    setTrainingEndDate(event.target.value);
  };

  const [finalizedCommercialsError, setFinalizedCommercialsError] = useState(false);

  const handleFinalizedCommercialsChange = (event) => {
    const input = event.target.value;
    const regex = /^[0-9]+$/;
    const isValid = !regex.test(input);
    setFinalizedCommercialsError(isValid);
    setFinalizedCommercials(event.target.value);
  };

  const handleExpectedPaymentDateChange = (event) => {
    setExpectedPaymentDate(event.target.value);
  };

  const handleExpectedNewPaymentDateChange = (event) => {
    setExpectedNewPaymentDate(event.target.value);
  };

  const handleFinalizedStartTimeChange = (event) => {
    setFinalizedStartTime(event.target.value);
  };

  const handleFinalizedEndTimeChange = (event) => {
    setFinalizedEndTime(event.target.value);
  };

  const handleFinalizedTrainingScheduleChange = (selectedDates) => {
    const formattedDates = selectedDates.map((date) => {
      return date.format('YYYY-MM-DD');
    });

    setFinalizedTrainingSchedule(formattedDates);
  };

  const handleFinalizedTrainingTimingChange = (e) => {
    setFinalizedTrainingTiming(e.target.value);
  };

  const [appliedTrainerDetails, setAppliedTrainerDetails] = useState([]);

  useEffect(() => {
    console.log("trainingID", trainingDetails.selectedTrainingID);
    fetch(`${process.env.REACT_APP_API_URL}/api/active-trainer-list/${trainingDetails.selectedTrainingID}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setAppliedTrainerDetails(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [trainingDetails, trainingID]);

  const onScheduleCancelClick = () => {
    setIsModalOpen(false);
    setFinalizedCommercialsError(false);
    setTrainingStartDate("");
    setTrainingEndDate("");
    setExpectedPaymentDate("");
    setFinalizedStartTime("");
    setFinalizedEndTime("");
    setFinalizedTrainingSchedule("");
    setFinalizedTrainingTiming("");
    setFinalizedCommercials("");
    setSelectedCurrencyCountry("");
    setCurrency("");
  };

  const [scheduleSelectedTrainer, setScheduleSelectedTrainer] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onScheduleTrainingClick = (trainer) => {
    console.log("@#2@@#@#", trainer);
    setScheduleSelectedTrainer(trainer);
    setIsModalOpen(true);
  };

  const onSubmitScheduleClick = (trainer) => {
    console.log("111111111111111111", trainer);
    const scheduleTraining = () => {
      // Your existing code for onScheduleTrainingClick
      setLoading(true);
      console.log("111111111111111111", trainer);
      let applyTraining = trainer.apply_training;
      const data = {
        applyTrainingStatus: "5",
        previousStatus: "4",
        appliedTrainerID: trainer.appliedTrainerID,
        trainingCompanyUserID: trainer.trainingCompanyUserID,
        selectedTrainingID: trainer.selectedTrainingID,
        selectedTrainingName: trainer.selectedTrainingName,
      };

      console.log(JSON.stringify(data));

      return fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          if (response.ok) {
            console.log("First POST call successful");

            // Set up an array to store promises for the second POST calls
            const secondPostPromises = [];

            // Handle the second POST calls for each trainer in restTrainers
            const restTrainers = appliedTrainerDetails.filter(
              (trainers) => parseInt(trainers.user_id) !== parseInt(trainer.appliedTrainerID)
            );

            console.log("restTrainers@@@@@@", restTrainers);
            restTrainers.forEach((restTrainer) => {
              const secondPostData = {
                applyTrainingStatus: "16",
                previousStatus: restTrainer.apply_training.applyTrainingStatus,
                appliedTrainerID: restTrainer.apply_training.appliedTrainerID,
                trainingCompanyUserID: restTrainer.apply_training.trainingCompanyUserID,
                selectedTrainingID: restTrainer.apply_training.selectedTrainingID,
                selectedTrainingName: restTrainer.apply_training.selectedTrainingName,
              };

              console.log(JSON.stringify(secondPostData));

              const secondPostPromise = fetch(
                `${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(secondPostData),
                }
              );

              secondPostPromises.push(secondPostPromise);
            });

            // Wait for all second POST calls to complete
            return Promise.all(secondPostPromises)
              .then(() => {
                console.log("All second POST calls successful");
                setSubmitTrainingScheduleCompleted(true);
                // setLoading(false);
              })
              .catch((error) => {
                console.log("Error in second POST calls", error.message);
                setSubmitTrainingScheduleCompleted(false);
              });
          } else {
            setSubmitTrainingScheduleCompleted(false);
            throw new Error("Response not posted. Something went wrong");
          }
        });
    };

    const data = {
      trainingStartDate: trainingStartDate,
      trainingEndDate: trainingEndDate,
      finalizedStarttime: finalizedStartTime,
      finalizedEndtime: finalizedEndTime,
      finalizedScheduledate: finalizedTrainingSchedule,
      finalizedTrainingHour: finalizedTrainingTiming,
      finalizedSelectedCommercialsCountry: selectedCurrencyCountry,
      finalizedCommercialsCurrency: currency,
      finalizedCommercials: finalizedCommercials,
      expectedPaymentDate: expectedPaymentDate,
    };
    console.log(JSON.stringify(data));
    return fetch(`${process.env.REACT_APP_API_URL}/api/training-update-date/${trainingDetails.selectedTrainingID}/`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          console.log("First POST call for training-update-date successful");
          // After the successful training-update-date API call, call the scheduleTraining function
          setIsModalOpen(false);
          return scheduleTraining();
        } else {
          setSubmitTrainingScheduleCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then(() => {
        console.log("All API calls successful");
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error in API calls", error.message);
        setSubmitTrainingScheduleCompleted(false);
      });
  };

  const onStartTrainingClick = (trainer) => {
    setLoading(true);
    console.log("111111111111111111", trainer);
    const data = {
      applyTrainingStatus: "7",
      previousStatus: "6",
      appliedTrainerID: trainer.appliedTrainerID,
      trainingCompanyUserID: trainer.trainingCompanyUserID,
      selectedTrainingID: trainer.selectedTrainingID,
      selectedTrainingName: trainer.selectedTrainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitStartTrainingCompleted(true);
          setLoading(false);
        } else {
          setSubmitStartTrainingCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const onTrainingCompletedClick = (trainer) => {
    console.log("111111111111111111", trainer);
    setLoading(true);
    const data = {
      applyTrainingStatus: "8",
      previousStatus: "7",
      appliedTrainerID: trainer.appliedTrainerID,
      trainingCompanyUserID: trainer.trainingCompanyUserID,
      selectedTrainingID: trainer.selectedTrainingID,
      selectedTrainingName: trainer.selectedTrainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setFeedbackStatusAvailable(true);
          // setSubmitAcceptCompleted(true);
          setLoading(false);
        } else {
          setSubmitAcceptCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/feedback-template-view/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          const trainerFeedbackQuestions = data.filter(
            (question) => question.toWhom === "TrainingCompany"
          );
          setFeedbackQuestions(trainerFeedbackQuestions);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  console.log("feedbackQuestions", feedbackQuestions);

  const handleRatingChange = (event, newValue) => {
    // Update the feedbackRating state with the selected rating
    setFeedbackRating(newValue);
  };


  const onSubmitFeebackClick = (trainer) => {
    setLoading(true);
    console.log("111111111111111111", trainer);
    const data = {
      trainerID: trainer.appliedTrainerID,
      trainingCompanyID: trainer.trainingCompanyUserID,
      trainingID: trainingID,
      toWhom: "Trainer",
      rating1: feedbackRating,
      question1: feedbackAnswer1,
      question2: feedbackAnswer2,
      question3: feedbackAnswer3,
      question4: feedbackAnswer4,
      question5: feedbackAnswer5,
      question6: feedbackAnswer6,
      question7: feedbackAnswer7,
      question8: feedbackAnswer8,
      status: "Active",
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/feedback-api-view/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setFeedbackStatusAvailable(false);
          setSubmitFeedbackCompleted(true);
          setLoading(false);
        } else {
          setFeedbackStatusAvailable(true);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };


  const onPaymentCompletedClick = (trainer) => {
    setLoading(true);
    console.log("111111111111111111", trainer);
    const data = {
      applyTrainingStatus: "10",
      previousStatus: "9",
      appliedTrainerID: trainer.appliedTrainerID,
      trainingCompanyUserID: trainer.trainingCompanyUserID,
      selectedTrainingID: trainer.selectedTrainingID,
      selectedTrainingName: trainer.selectedTrainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitPaymentCompleted(true);
          setLoading(false);
        } else {
          setSubmitPaymentCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const DialogProfileClose = () => {
    setSubmitCompleted(false);
    // window.location.href = "/app/appliedtrainermoredetails";
    window.location.href = `/app/appliedtrainermoredetails/${trainingID}/`;
  };

  const DialogTrainerAcceptClose = () => {
    setSubmitTrainerAcceptCompleted(false);
    window.location.href = `/app/appliedtrainermoredetails/${trainingID}/`;
  };

  const DialogStartDiscussionClose = () => {
    setSubmitStartDiscussionCompleted(false);
    window.location.href = `/app/appliedtrainermoredetails/${trainingID}/`;
  };

  const DialogTrainingScheduleClose = () => {
    setSubmitTrainingScheduleCompleted(false);
    window.location.href = `/app/appliedtrainermoredetails/${trainingID}/`;
  };

  const DialogProfileStartTrainingClose = () => {
    setSubmitStartTrainingCompleted(false);
    window.location.href = `/app/appliedtrainermoredetails/${trainingID}/`;
  };

  const DialogProfileFeedbackClose = () => {
    setSubmitFeedbackCompleted(false);
    window.location.href = `/app/appliedtrainermoredetails/${trainingID}/`;
  };

  const DialogProfilePaymentCompletedClose = () => {
    setSubmitPaymentCompleted(false);
    window.location.href = `/app/appliedtrainermoredetails/${trainingID}/`;
  };

  const onCancelClick = () => {
    window.location.href = `/app/activetrainingmoredetails/${trainingDetails.selectedTrainingID}/`;
  };

  // function getStatusMessage(trainingDetails) {
  //   if (trainingDetails.applyTrainingStatus === "1") {
  //     return "Awaiting For your response";
  //   } else if (trainingDetails.applyTrainingStatus === "2") {
  //     return "Company - Accepted. Awaiting for Trainer's response";
  //   } else if (trainingDetails.applyTrainingStatus === "Yes") {
  //     return "Trainer Declined the training";
  //   } else if (trainingDetails.applyTrainingStatus === "3") {
  //     return "Mutually agreed for the training";
  //   } else if (trainingDetails.applyTrainingStatus === "Yes") {
  //     return "You have Declined the trainer";
  //   } else {
  //     return "Unknown Status";
  //   }
  // }

  function getStatusMessage(trainingDetails) {
    console.log("status11111111", trainingDetails.applyTrainingStatus);
    if (trainingDetails.applyTrainingStatus === "1") {
      return "Awaiting For your response";
    } else if (trainingDetails.applyTrainingStatus === "2") {
      return "Partner - Accepted. Awaiting for Trainer's response";
    } else if (trainingDetails.applyTrainingStatus === "13") {
      return "Trainer Declined the training";
    } else if (trainingDetails.applyTrainingStatus === "3") {
      return "Mutually agreed for the training";
    } else if (trainingDetails.applyTrainingStatus === "14") {
      return "You have Declined the trainer";
    } else if (trainingDetails.applyTrainingStatus === "4") {
      return "Discussion on-going with trainer";
    } else if (trainingDetails.applyTrainingStatus === "5") {
      return "Training Scheduling on-going with trainer";
    } else if (trainingDetails.applyTrainingStatus === "6") {
      return "Training Scheduling confirmed with trainer";
    } else if (trainingDetails.applyTrainingStatus === "7") {
      return "Training has been Started";
    } else if (trainingDetails.applyTrainingStatus === "8") {
      return "Training has been Completed";
    } else if (trainingDetails.applyTrainingStatus === "9") {
      return "Invoice sent by Trainer. Initiate Payment";
    } else if (trainingDetails.applyTrainingStatus === "10") {
      return "Payment Completed. Awaiting Trainer's Confirmation";
    } else if (trainingDetails.applyTrainingStatus === "11") {
      return "Payment Received by the Trainer";
    } else if (trainingDetails.applyTrainingStatus === "12") {
      return "Payment Not Received by the Trainer";
    } else if (trainingDetails.applyTrainingStatus === "16") {
      return "Trainer request is on-hold";
    } else if (trainingDetails.applyTrainingStatus === "17") {
      return "1st New Payment Date has been submitted";
    } else if (trainingDetails.applyTrainingStatus === "18") {
      return "2nd New Payment Date has been submitted";
    } else if (trainingDetails.applyTrainingStatus === "19") {
      return "Final New Payment Date has been submitted";
    } else {
      return "Unknown Status";
    }
  }

  const handleTrainerTocDownloadClick = (trainingDetails) => {
    window.location.href = `${process.env.REACT_APP_API_URL}/api/download/${trainingDetails.tocURL}/applytraining/${trainingDetails.trainingName}_${trainingDetails.selectedTrainingID}_toc`;
  };

  const handleTrainingCompanyTocDownloadClick = (trainingDetails) => {
    window.location.href = `${process.env.REACT_APP_API_URL}/api/download/${trainingDetails.TOCURL}/trainingpost/${trainingDetails.selectedTrainingName}_toc`;
  };

  const handleResumeDownloadClick = (trainerList) => {
    window.location.href = `${process.env.REACT_APP_API_URL}/api/download/${trainerList.S3BucketURL}/resume/${trainerList.uploadedResumeName}`;
  };

  return (
    <>
      <LoadingOverlay loading={loading}>
        <IdleTimeOutHandler />
        <DefaultNavbar
          routes={routes}
        />
        <MKBox bgColor="white">
          {/* <MKBox
          minHeight="35rem"
          width="100%"
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.3),
                rgba(gradients.dark.state, 0.3)
              )}, url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center center",
            display: "grid",
            placeItems: "center",
          }}
        /> */}
          <Card
            sx={{
              p: 2,
              mx: { xs: 2, lg: 3 },
              // mt: -8,
              mb: 4,
              // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
              backdropFilter: "saturate(200%) blur(30px)",
              boxShadow: ({ boxShadows: { xxl } }) => xxl,
            }}
          >
            <Dialog
              open={submitAcceptCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Notification !
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Your response submitted to the trainer.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitAcceptCompleted(false); DialogProfileAcceptClose(); }} variant="gradient" color="info" size="small"  autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Great news!
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Reminder sent successfully! Your gentle nudge has been delivered.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitCompleted(false); DialogProfileClose(); }} variant="gradient" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitTrainerAcceptCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Success!
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Your message has been successfully submitted to the trainer. Please await confirmation as the trainer reviews and accepts your request. Thank you for your patience!
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitTrainerAcceptCompleted(false); DialogTrainerAcceptClose(); }} variant="gradient" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitStartDiscussionCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Time to kick off a conversation!
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Begin the discussion with the trainer to explore and plan your training journey together.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitStartDiscussionCompleted(false); DialogStartDiscussionClose(); }} variant="gradient" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitTrainingScheduleCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Great news!
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Your training schedule has been formally submitted. Kindly communicate with the trainer and request confirmation through the portal. Thank you!
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitTrainingScheduleCompleted(false); DialogTrainingScheduleClose(); }} variant="gradient" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitStartTrainingCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Notification !
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  The trainer has been notified about the start of the training.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitStartTrainingCompleted(false); DialogProfileStartTrainingClose(); }} variant="gradient" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitFeedbackCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Thank you!
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Your Feedback has been submitted to the trainer.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitFeedbackCompleted(false); DialogProfileFeedbackClose(); }} variant="gradient" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <Dialog
              open={submitPaymentCompleted}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                Great news!
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Your confirmation of payment has been successfully shared with the trainer.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                <MKButton onClick={() => { setSubmitPaymentCompleted(false); DialogProfilePaymentCompletedClose(); }} variant="gradient" color="info" size="small" autoFocus>
                  OK
                </MKButton>
              </DialogActions>
            </Dialog>
            <MKBox component="section" py={{ xs: 6, sm: 12 }}>
              <Container>
                <div>
                  {maxRemainderCount ? (
                    <MKAlert color="error" dismissible >
                      You've reached the daily remainder limit !
                    </MKAlert>
                  ) : (
                    ""
                  )}
                </div>
                <Grid container item xs={12} justifyContent="center" mx="auto">
                  <Grid container justifyContent="center" py={6} style={{ marginTop: "-50px" }}>
                    <Grid item xs={12} md={12} mx={{ xs: "auto", sm: 6, md: 1 }}>
                      {/* <MKTypography component="span" variant="body2" fontWeight="regular" color="text">
                Please review the details of the trainer who has applied for the training you posted, named '{selectedTrainingName}'. You can either select 'Accept' to proceed with this trainer or 'Decline' to reject their application.
              </MKTypography> */}
                      <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                        <Typography variant="h3">{trainingDetails.trainingName}</Typography>
                      </MKBox>

                      <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                        <Grid item>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Training by :
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "10px" }}>
                            {trainingDetails.trainingCompanyName}
                          </Typography>
                        </Grid>
                      </MKBox>

                      <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                        <Grid item>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Technology:
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "10px" }}>
                            {trainingDetails.technology}
                          </Typography>
                        </Grid>
                      </MKBox>

                      <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                        <Grid item>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            <strong>Status:</strong>
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "10px" }}>
                            <strong>{getStatusMessage(trainingDetails)}</strong>
                          </Typography>
                        </Grid>
                      </MKBox>

                      <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                        <Grid item xs={12}>
                          <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Training Details</span> }]} />
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Mode Of Training :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "48px" }}>
                            {trainingDetails.trainingMode}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Training Location :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "50px" }}>
                            {trainingDetails.trainingMode === "Virtual" ? "N/A" : trainingDetails.trainingLocations}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Time Zone :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "88px" }}>
                            {trainingDetails.timeZone}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }} >
                            Audience Level :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "63px" }}>
                            {trainingDetails.audienceLevel}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Training Expectation :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "27px" }}>
                            {trainingDetails.trainingExpectation}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Training Type :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "69px" }}>
                            {trainingDetails.trainingType}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Total Participants :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "47px" }}>
                            {trainingDetails.totalParticipants}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Total Training Budget :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "20px" }}>
                            {trainingDetails.currency}&nbsp;{trainingDetails.totalTrainingBudget}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Total Duration :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "63px" }}>
                            {trainingDetails.duration}&nbsp;hours
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Training Timing :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "63px" }}>
                            {trainingDetails.trainingTiming}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Start Time :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "99px" }}>
                            {trainingDetails.startTime}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            End Time :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "100px" }}>
                            {trainingDetails.endTime}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Expected Start Date :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "34px" }}>
                            {trainingDetails.expectedStartDate}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Expected End Date :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "35px" }}>
                            {trainingDetails.deadline}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            TOC Available :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "70px" }}>
                            {trainingDetails.tocAvailable === 'yes' ? 'Yes' : 'No'}
                          </Typography>
                        </Grid>
                      </Grid>



                      {trainingDetails.tocAvailable === 'yes' && (
                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                            <MKButton variant="gradient" color="info" size="small" style={{ padding: '5px 10px' }} onClick={() => handleTrainingCompanyTocDownloadClick(trainingDetails)}>
                              Download Training Partner TOC
                            </MKButton>
                          </Grid>
                        </Grid>
                      )}

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={12}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Training Schedule :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "58px" }}>
                            {/* {trainingDetails.trainingSchedule} */}
                            {trainingDetails.trainingSchedule
                              ? trainingDetails.trainingSchedule
                                .replace(/'/g, "")
                                .replace(/\[|\]/g, "")
                                .split(", ")
                                .join(", ")
                              : ""}
                          </Typography>
                        </Grid>
                      </Grid>

                      {trainingDetails.trainingScheduleComment && (
                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={2}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Schedule Comments :&nbsp;
                            </Typography>
                          </Grid>
                          <Grid item xs={10}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "0px" }}>
                              {trainingDetails.trainingScheduleComment} <br />
                            </Typography>
                          </Grid>
                        </Grid>
                      )}

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={2}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Requirements :&nbsp;
                          </Typography>
                        </Grid>
                        <Grid item xs={10}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "0px" }}>
                            {trainingDetails.requirements} <br />
                          </Typography>
                        </Grid>
                      </Grid>

                      {(
                        trainingCompanyProfileDetails.premiumStatus === "yes" ||
                        (parseInt(trainingDetails.applyTrainingStatus) >= 3 && parseInt(trainingDetails.previousStatus) >= 2)
                      ) && (
                          <>
                            <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                              <Grid item xs={12}>
                                <Breadcrumbs
                                  routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer's Contact Details</span> }]}
                                />
                              </Grid>
                            </Grid>
                            <Grid container spacing={4} mb={1}>
                              <Grid item xs={4}>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                  Contact Person Name :&nbsp;
                                </Typography>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "37px" }}>
                                  {trainerDetails.firstName}&nbsp;{trainerDetails.lastName}
                                </Typography>
                              </Grid>
                              <Grid item xs={4}>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                                  Email - ID :&nbsp;
                                </Typography>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "50px" }}>
                                  {trainerDetails.email}&nbsp;
                                </Typography>
                              </Grid>
                              <Grid item xs={4}>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text">
                                  Mobile Number :&nbsp;
                                </Typography>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "70px" }}>
                                  {trainerDetails.mobileNumber}&nbsp;
                                </Typography>
                              </Grid>
                            </Grid>
                          </>
                        )}

                      <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                        <Grid item xs={12}>
                          <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Trainer Application Details</span> }]} />
                        </Grid>
                      </Grid>

                      {parseInt(trainingDetails.applyTrainingStatus) >= 3 && parseInt(trainingDetails.previousStatus) >= 2 && (
                        <>
                          {trainingDetails.uploadedResumeName && (
                            <Grid container spacing={4} mb={1}>
                              <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                                <MKButton variant="gradient" color="info" size="small" style={{ padding: '5px 10px' }} onClick={() => handleResumeDownloadClick(trainingDetails)}>
                                  Download Resume
                                </MKButton>
                              </Grid>
                            </Grid>
                          )}
                        </>
                      )}

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Last Delivered Date :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "70px" }}>
                            {trainingDetails.recentLastDeliveredDate}
                          </Typography>
                        </Grid>
                        <Grid item xs={8}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Last Delivered Client :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "63px" }}>
                            {trainingDetails.recentLastDeliveredClient}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Commercials For &lt;4hrs :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "44px" }}>
                            {trainingDetails.currency}&nbsp;{trainingDetails.commercialsForLessThan4hrs}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Commercials For 4hrs :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "54px" }}>
                            {trainingDetails.currency}&nbsp;{trainingDetails.commercialsFor4hrs}
                          </Typography>
                        </Grid>
                        <Grid item xs={4}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Commercials For 8hrs :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "54px" }}>
                            {trainingDetails.currency}&nbsp;{trainingDetails.commercialsFor8hrs}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={12}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Total Training Duration :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', marginLeft: "48px" }}>
                            {trainingDetails.courseDurationHRS} hours
                          </Typography>
                        </Grid>
                      </Grid>

                      {trainingDetails.availableDatesForTraining && trainingDetails.availableDatesForTraining !== "[]" && (
                        <>
                          <Grid container spacing={4} mb={1}>
                            <Grid item xs={12}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Available Dates for Training :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "18px" }}>
                                {trainingDetails.availableDatesForTraining
                                  ? trainingDetails.availableDatesForTraining
                                    .replace(/'/g, "")
                                    .replace(/\[|\]/g, "")
                                    .split(", ")
                                    .join(", ")
                                  : ""}
                              </Typography>
                            </Grid>
                          </Grid>
                        </>
                      )}

                      {trainingDetails.availableDatesForCall && trainingDetails.availableDatesForCall !== "[]" && (
                        <>
                          <Grid container spacing={4} mb={1}>
                            <Grid item xs={12}>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Available Dates for Call :&nbsp;
                              </Typography>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "48px" }}>
                                {trainingDetails.availableDatesForCall
                                  ? trainingDetails.availableDatesForCall
                                    .replace(/'/g, "")
                                    .replace(/\[|\]/g, "")
                                    .split(", ")
                                    .join(", ")
                                  : ""}
                              </Typography>
                            </Grid>
                          </Grid>
                        </>
                      )}

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                          <MKButton variant="gradient" color="info" size="small" style={{ padding: '5px 10px' }} onClick={() => handleTrainerTocDownloadClick(trainingDetails)}>
                            Download Trainer TOC
                          </MKButton>
                        </Grid>
                      </Grid>

                      {trainingDetails.comments && (
                        <Grid container spacing={4} mb={1}>
                          <Grid item xs={12}>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                              Comments :&nbsp;
                            </Typography>
                            <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "16px" }}>
                              {trainingDetails.comments}
                            </Typography>
                          </Grid>
                        </Grid>
                      )}

                      {/* <Grid container spacing={4} mb={1}>
                <Grid item xs={12}>
                  <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{marginLeft : "15px"}}>
                    Status :&nbsp;
                  </Typography>
                  <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{marginLeft : "48px"}}>
                    {getStatusMessage(trainingDetails)}
                  </Typography>
                </Grid>
              </Grid> */}

                    </Grid>
                  </Grid>
                  <Grid container justifyContent="center" spacing={2} mt={2} style={{ marginTop: "-40px", marginBottom: "-80px" }}>
                    <Grid item>
                      <MKButton
                        variant="gradient"
                        color="info"
                        size="small"
                        onClick={() => onCancelClick()}
                        style={{ padding: '5px 10px' }}
                      >
                        Back
                      </MKButton>
                    </Grid>
                    {parseInt(trainingDetails.applyTrainingStatus) === 2 && (
                      <>
                        <Grid item>
                          <MKButton
                            variant="gradient"
                            color="info"
                            size="small"
                            onClick={() => onRemainderClick(trainingDetails)}
                            style={{ padding: '5px 10px' }}
                          >
                            Send Remainder
                          </MKButton>
                        </Grid>
                      </>
                    )}

                    {parseInt(trainingDetails.applyTrainingStatus) === 1 && (
                      <>
                        <Grid item>
                          <MKButton
                            variant="gradient"
                            color="info"
                            size="small"
                            onClick={() => onAgreeClick(trainingDetails)}
                            style={{ padding: '5px 10px' }}
                          >
                            Accept
                          </MKButton>
                        </Grid>
                      </>
                    )}
                    {parseInt(trainingDetails.applyTrainingStatus) === 3 && (
                      <>
                        <Grid item>
                          <MKButton variant="gradient" color="info" size="small" onClick={() => onStartDiscussionClick(trainingDetails)} style={{ padding: '5px 10px' }}>Start Discussion</MKButton>
                        </Grid>
                      </>
                    )}

                    {parseInt(trainingDetails.applyTrainingStatus) === 4 && (
                      <>
                        <Grid item>
                          <MKButton variant="gradient" color="info" size="small" onClick={() => onScheduleTrainingClick(trainingDetails)} style={{ padding: '5px 10px' }}>Schedule Training</MKButton>
                        </Grid>
                      </>
                    )}

                    {isModalOpen && (
                      <Modal open={isModalOpen === true} onClose={() => { onScheduleCancelClick(); }} sx={{ display: "grid", placeItems: "center" }}>
                        <MKBox
                          position="relative"
                          width="580px"
                          display="flex"
                          flexDirection="column"
                          borderRadius="xl"
                          bgColor="white"
                          shadow="xl"
                        >
                          <h2 style={{ whiteSpace: 'nowrap', fontSize: 'large', marginLeft: '10px', marginTop: '10px' }}>
                            Share Details to Schedule Training - {trainingDetails.trainingName}
                          </h2>
                          <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                            <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                              Training Start Date * :
                            </Typography>
                            <MKInput
                              type="date"
                              id="training_startDate"
                              style={{ marginLeft: '57px', width: '200px' }}
                              value={trainingStartDate || ""}
                              onChange={handleTrainingStartDateChange}
                              placeholder={trainingStartDate ? "" : "Training Start Date"}
                              inputProps={{ min: today }}
                            // fullwidth
                            />
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                            <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                              Training End Date * :
                            </Typography>
                            <MKInput
                              type="date"
                              id="training_endDate"
                              style={{ marginLeft: '65px', width: '200px' }}
                              value={trainingEndDate || ""}
                              onChange={handleTrainingEndDateChange}
                              placeholder={trainingEndDate ? "" : "Training End Date"}
                              inputProps={{ min: today }}
                            // fullwidth
                            />
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                            <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                              Expected Payment Date * :
                            </Typography>
                            <MKInput
                              type="date"
                              id="expected_paymentDate"
                              style={{ marginLeft: '20px', width: '200px' }}
                              value={expectedPaymentDate || ""}
                              onChange={handleExpectedPaymentDateChange}
                              placeholder={expectedPaymentDate ? "" : "Expected Payment Date"}
                              inputProps={{ min: today }}
                            // fullwidth
                            />
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                            <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                              Finalized Training Hours * :
                            </Typography>
                            <FormControl variant="outlined">
                              <InputLabel style={{ marginLeft: '17px' }} id="Training Timing*">Per day</InputLabel>
                              <Select
                                labelId="TrainingTiming"
                                label="Per day"
                                fullWidth
                                onChange={handleFinalizedTrainingTimingChange}
                                value={finalizedTrainingTiming}
                                style={{ minHeight: '44px', marginLeft: '18px', width: '200px' }}
                              >
                                <MenuItem value="less than 4 hours">less than 4 hours</MenuItem>
                                <MenuItem value="4 hours">4 hours</MenuItem>
                                <MenuItem value="8 hours">8 hours</MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                            <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                              Finalized Start Time * :
                            </Typography>
                            <TextField
                              label="Start Time"
                              type="time"
                              value={finalizedStartTime}
                              onChange={handleFinalizedStartTimeChange}
                              style={{ marginLeft: '48px', width: '200px' }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                step: 300,
                              }}
                            />
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                            <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                              Finalized End Time * :
                            </Typography>
                            <TextField
                              label="End Time"
                              type="time"
                              value={finalizedEndTime}
                              onChange={handleFinalizedEndTimeChange}
                              style={{ marginLeft: '56px', width: '200px' }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              inputProps={{
                                step: 300,
                              }}
                            />
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                            <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                              Finalized Training Schedule *
                              <DatePicker
                                multiple
                                id="selectedDates"
                                style={{ marginLeft: '20px' }}
                                render={<CustomMultipleInput />}
                                onChange={handleFinalizedTrainingScheduleChange}
                                value={finalizedTrainingSchedule}
                                // minDate={new Date()}
                                // maxDate={fbmaxDate}
                                minDate={new Date(trainingStartDate)}
                                maxDate={new Date(trainingEndDate)}
                              />
                            </Typography>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                            {finalizedTrainingSchedule.length > 0 && (
                              <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                <Typography style={{ fontSize: 'medium' }}>
                                  Finalized Dates For Training:
                                </Typography>{' '}
                                {finalizedTrainingSchedule.join(', ')}
                              </Typography>
                            )}
                          </div>
                          <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "20px", marginRight: "22px" }}>
                            <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Finalized Commericals (Total Cost for the Training)</span> }]} />
                          </Grid>
                          <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                            <Grid item xs={12} md={4} style={{ marginTop: "20px", marginLeft: '10px' }}>
                              <div>
                                <FormControl variant="outlined" style={{ width: '200px' }}>
                                  <InputLabel id="country-currency" shrink={!!selectedCurrencyCountry}>Country *</InputLabel>
                                  <Select
                                    labelId="country-currency"
                                    label="Country *"
                                    fullWidth
                                    onChange={handleCountryCurrencyChange}
                                    value={selectedCurrencyCountry}
                                    style={{ minHeight: '44px' }}
                                  >
                                    {getAllISOCodes().map((country) => (
                                      <MenuItem key={country.iso} value={country.iso}>
                                        {country.countryName}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </div>
                            </Grid>
                            <Grid item xs={12} md={4} style={{ marginTop: "20px", marginLeft: '20px' }}>
                              <div>
                                <Typography variant="subtitle2" style={{ marginTop: "10px" }}>
                                  <span>Currency: {currency}</span>
                                </Typography>
                              </div>
                            </Grid>
                            <Grid item xs={12} md={4} style={{ marginTop: "16px" }}>
                              <div>
                                <TextField
                                  label="Commericals *"
                                  name="finalizedCommercials"
                                  value={finalizedCommercials}
                                  onChange={handleFinalizedCommercialsChange}
                                  style={{ minHeight: '44px', width: '200px', marginLeft: '-45px', borderColor: finalizedCommercialsError ? 'red' : undefined }}
                                  error={finalizedCommercialsError}
                                />
                              </div>
                            </Grid>
                          </div>
                          {/* <div style={{ display: 'flex', alignItems: 'center',marginTop: '10px'  }}>
                    <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                      Finalized Commericals :
                    </Typography>
                    
                  </div> */}
                          {/* <div style={{ display: 'flex', justifyContent: 'flex-start', marignLeft: '10px',marginBottom: '10px',marginTop: '20px' }}>
                    <MKButton variant="outlined" color="info" size="small"
                    onClick={() => onSubmitScheduleClick(scheduleSelectedTrainer)}>Cancel</MKButton>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'flex-end',marignRight: '10px', marginBottom: '10px',marginTop: '-40px' }}>
                    <MKButton variant="outlined" color="info" size="small" disabled={!trainingStartDate || !trainingEndDate || !expectedPaymentDate || !selectedCurrencyCountry || !currency || !finalizedCommercials ||
                      !finalizedStartTime || !finalizedEndTime || !finalizedTrainingSchedule || !finalizedTrainingTiming } 
                    onClick={() => onSubmitScheduleClick(scheduleSelectedTrainer)} style={{ padding: '5px 10px' }}>Submit Schedule</MKButton>
                  </div> */}
                          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px', marginTop: '20px' }}>
                            <MKButton variant="gradient" color="info" size="small" onClick={() => { onScheduleCancelClick(); }} style={{ padding: '5px 10px' }}>Cancel</MKButton>
                            <MKButton variant="gradient" color="info" size="small" disabled={!trainingStartDate || !trainingEndDate || !expectedPaymentDate || !selectedCurrencyCountry || !currency || !finalizedCommercials ||
                              !finalizedStartTime || !finalizedEndTime || !finalizedTrainingSchedule || !finalizedTrainingTiming || finalizedCommercialsError}
                              onClick={() => onSubmitScheduleClick(scheduleSelectedTrainer)} style={{ marginLeft: '10px', padding: '5px 10px' }}>Submit Schedule</MKButton>
                          </div>
                        </MKBox>
                      </Modal>
                    )}

                    {parseInt(trainingDetails.applyTrainingStatus) === 6 && (
                      <Grid item>
                        {new Date() >= new Date(trainingDetails.trainingStartDate) ? (
                          <MKButton variant="gradient" color="info" size="small" onClick={() => onStartTrainingClick(trainingDetails)} style={{ padding: '5px 10px' }}>
                            Start Training
                          </MKButton>
                        ) : (
                          <MKButton variant="gradient" color="dark" size="small" disabled style={{ padding: '5px 10px' }}>
                            Start Training
                          </MKButton>
                        )}
                      </Grid>
                      // <>
                      //   <Grid item>
                      //     <MKButton variant="gradient" color="info" size="small" onClick={() => onStartTrainingClick(trainingDetails)} style={{ padding: '5px 10px' }}>Start Training</MKButton>
                      //   </Grid>
                      // </>
                    )}

                    {parseInt(trainingDetails.applyTrainingStatus) === 7 && (
                      <>
                        <Grid item>
                          {new Date() >= new Date(trainingDetails.trainingEndDate) ? (
                            <MKButton variant="gradient" color="info" size="small" onClick={() => onTrainingCompletedClick(trainingDetails)} style={{ padding: '5px 10px' }}>
                              Training Completed
                            </MKButton>
                          ) : (
                            <MKButton variant="gradient" color="dark" size="small" disabled style={{ padding: '5px 10px' }}>
                              Training Completed
                            </MKButton>
                          )}
                        </Grid>
                        {/* <>
                <Grid item>
                  <MKButton variant="gradient" color="info" size="small" onClick={() => onTrainingCompletedClick(trainingDetails)} style={{ padding: '5px 10px' }}>Training Completed</MKButton>
                </Grid> */}
                      </>
                    )}

                    {feedbackStatusAvailable && (
                      <div>
                        {/* {getFeedbackStatus(trainer)}                                */}
                        <Modal open={feedbackStatusAvailable === true} onClose={() => setShowFeedbackModal(false)} sx={{ display: "grid", placeItems: "center" }}>
                          <MKBox
                            position="relative"
                            width="830px"
                            display="flex"
                            flexDirection="column"
                            borderRadius="xl"
                            bgColor="white"
                            shadow="xl"
                          >
                            <div style={{ maxHeight: '90vh', overflowY: 'auto' }}>
                              <h2 style={{ whiteSpace: 'nowrap', fontSize: 'large', marginLeft: '10px', marginTop: '10px' }}>
                                Feedback for the {trainingDetails.trainingName} Training for the Trainer - {trainerDetails.firstName}&nbsp;{trainerDetails.lastName}
                              </h2>
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                  Share your feedback by providing a rating for the trainer's performance * -
                                </Typography>
                                <Stack spacing={1} style={{ marginLeft: '20px', marginTop: '10px' }}>
                                  <Rating
                                    name="half-rating"
                                    value={feedbackRating}
                                    precision={0.5}
                                    onChange={handleRatingChange}
                                  />
                                </Stack>
                              </div>
                              <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                {feedbackQuestions.length > 0 && feedbackQuestions[0].question}
                              </Typography>
                              <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                <div>
                                  <TextField
                                    label="Min: 10 characters, Max: 500 characters"
                                    multiline
                                    rows={4}
                                    variant="outlined"
                                    style={{
                                      width: '650px', marginLeft: "20px",
                                      borderColor: feedbackAnswer1.length >= 10 && feedbackAnswer1.length <= 500 && isFeedback1Interacted
                                        ? "initial"
                                        : "initial",
                                    }}
                                    value={feedbackAnswer1}
                                    error={isFeedback1Interacted && (feedbackAnswer1.length < 10 || feedbackAnswer1.length > 500)}
                                    helperText={
                                      isFeedback1Interacted && (feedbackAnswer1.length < 10 || feedbackAnswer1.length > 500)
                                        ? ""
                                        : ""
                                    }
                                    onChange={(e) => {
                                      setFeedbackAnswer1(e.target.value);
                                    }}
                                    onFocus={() => setIsFeedback1Interacted(true)}
                                  />
                                </div>
                              </Grid>
                              <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                {feedbackQuestions.length > 0 && feedbackQuestions[1].question}
                              </Typography>
                              <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                <div>
                                  <TextField
                                    label="Min: 10 characters, Max: 500 characters"
                                    multiline
                                    rows={4}
                                    variant="outlined"
                                    style={{
                                      width: '650px', marginLeft: "20px",
                                      borderColor: feedbackAnswer2.length >= 10 && feedbackAnswer2.length <= 500 && isFeedback2Interacted
                                        ? "initial"
                                        : "initial",
                                    }}
                                    value={feedbackAnswer2}
                                    fullWidth
                                    error={isFeedback2Interacted && (feedbackAnswer2.length < 10 || feedbackAnswer2.length > 500)}
                                    helperText={
                                      isFeedback2Interacted && (feedbackAnswer2.length < 10 || feedbackAnswer2.length > 500)
                                        ? ""
                                        : ""
                                    }
                                    onChange={(e) => {
                                      setFeedbackAnswer2(e.target.value);
                                    }}
                                    onFocus={() => setIsFeedback2Interacted(true)}
                                  />
                                </div>
                              </Grid>
                              <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                {feedbackQuestions.length > 0 && feedbackQuestions[2].question}
                              </Typography>
                              <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                <div>
                                  <TextField
                                    label="Min: 10 characters, Max: 500 characters"
                                    multiline
                                    rows={4}
                                    variant="outlined"
                                    style={{
                                      width: '650px', marginLeft: "20px",
                                      borderColor: feedbackAnswer3.length >= 10 && feedbackAnswer3.length <= 500 && isFeedback3Interacted
                                        ? "initial"
                                        : "initial",
                                    }}
                                    value={feedbackAnswer3}
                                    fullWidth
                                    error={isFeedback3Interacted && (feedbackAnswer3.length < 10 || feedbackAnswer3.length > 500)}
                                    helperText={
                                      isFeedback3Interacted && (feedbackAnswer3.length < 10 || feedbackAnswer3.length > 500)
                                        ? ""
                                        : ""
                                    }
                                    onChange={(e) => {
                                      setFeedbackAnswer3(e.target.value);
                                    }}
                                    onFocus={() => setIsFeedback3Interacted(true)}
                                  />
                                </div>
                              </Grid>
                              <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                {feedbackQuestions.length > 0 && feedbackQuestions[3].question}
                              </Typography>
                              <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                <div>
                                  <TextField
                                    label="Min: 10 characters, Max: 500 characters"
                                    multiline
                                    rows={4}
                                    variant="outlined"
                                    style={{
                                      width: '650px', marginLeft: "20px",
                                      borderColor: feedbackAnswer4.length >= 10 && feedbackAnswer4.length <= 500 && isFeedback4Interacted
                                        ? "initial"
                                        : "initial",
                                    }}
                                    value={feedbackAnswer4}
                                    fullWidth
                                    error={isFeedback4Interacted && (feedbackAnswer4.length < 10 || feedbackAnswer4.length > 500)}
                                    helperText={
                                      isFeedback2Interacted && (feedbackAnswer4.length < 10 || feedbackAnswer4.length > 500)
                                        ? ""
                                        : ""
                                    }
                                    onChange={(e) => {
                                      setFeedbackAnswer4(e.target.value);
                                    }}
                                    onFocus={() => setIsFeedback4Interacted(true)}
                                  />
                                </div>
                              </Grid><Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                {feedbackQuestions.length > 0 && feedbackQuestions[4].question}
                              </Typography>
                              <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                <div>
                                  <TextField
                                    label="Min: 10 characters, Max: 500 characters"
                                    multiline
                                    rows={4}
                                    variant="outlined"
                                    style={{
                                      width: '650px', marginLeft: "20px",
                                      borderColor: feedbackAnswer5.length >= 10 && feedbackAnswer5.length <= 500 && isFeedback5Interacted
                                        ? "initial"
                                        : "initial",
                                    }}
                                    value={feedbackAnswer5}
                                    fullWidth
                                    error={isFeedback5Interacted && (feedbackAnswer5.length < 10 || feedbackAnswer5.length > 500)}
                                    helperText={
                                      isFeedback5Interacted && (feedbackAnswer5.length < 10 || feedbackAnswer5.length > 500)
                                        ? ""
                                        : ""
                                    }
                                    onChange={(e) => {
                                      setFeedbackAnswer5(e.target.value);
                                    }}
                                    onFocus={() => setIsFeedback5Interacted(true)}
                                  />
                                </div>
                              </Grid>
                              <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                {feedbackQuestions.length > 0 && feedbackQuestions[5].question}
                              </Typography>
                              <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                <div>
                                  <TextField
                                    label="Min: 10 characters, Max: 500 characters"
                                    multiline
                                    rows={4}
                                    variant="outlined"
                                    style={{
                                      width: '650px', marginLeft: "20px",
                                      borderColor: feedbackAnswer6.length >= 10 && feedbackAnswer6.length <= 500 && isFeedback6Interacted
                                        ? "initial"
                                        : "initial",
                                    }}
                                    value={feedbackAnswer6}
                                    fullWidth
                                    error={isFeedback6Interacted && (feedbackAnswer6.length < 10 || feedbackAnswer6.length > 500)}
                                    helperText={
                                      isFeedback6Interacted && (feedbackAnswer6.length < 10 || feedbackAnswer6.length > 500)
                                        ? ""
                                        : ""
                                    }
                                    onChange={(e) => {
                                      setFeedbackAnswer6(e.target.value);
                                    }}
                                    onFocus={() => setIsFeedback6Interacted(true)}
                                  />
                                </div>
                              </Grid>
                              <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                {feedbackQuestions.length > 0 && feedbackQuestions[6].question}
                              </Typography>
                              <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                <div>
                                  <TextField
                                    label="Min: 10 characters, Max: 500 characters"
                                    multiline
                                    rows={4}
                                    variant="outlined"
                                    style={{
                                      width: '650px', marginLeft: "20px",
                                      borderColor: feedbackAnswer7.length >= 10 && feedbackAnswer7.length <= 500 && isFeedback7Interacted
                                        ? "initial"
                                        : "initial",
                                    }}
                                    value={feedbackAnswer7}
                                    fullWidth
                                    error={isFeedback7Interacted && (feedbackAnswer7.length < 10 || feedbackAnswer7.length > 500)}
                                    helperText={
                                      isFeedback7Interacted && (feedbackAnswer7.length < 10 || feedbackAnswer7.length > 500)
                                        ? ""
                                        : ""
                                    }
                                    onChange={(e) => {
                                      setFeedbackAnswer7(e.target.value);
                                    }}
                                    onFocus={() => setIsFeedback7Interacted(true)}
                                  />
                                </div>
                              </Grid>
                              <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                {feedbackQuestions.length > 0 && feedbackQuestions[7].question}
                              </Typography>
                              <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                <div>
                                  <TextField
                                    label="Min: 10 characters, Max: 500 characters"
                                    multiline
                                    rows={4}
                                    variant="outlined"
                                    style={{
                                      width: '650px', marginLeft: "20px",
                                      borderColor: feedbackAnswer8.length >= 10 && feedbackAnswer8.length <= 500 && isFeedback8Interacted
                                        ? "initial"
                                        : "initial",
                                    }}
                                    value={feedbackAnswer8}
                                    fullWidth
                                    error={isFeedback8Interacted && (feedbackAnswer8.length < 10 || feedbackAnswer8.length > 500)}
                                    helperText={
                                      isFeedback8Interacted && (feedbackAnswer8.length < 10 || feedbackAnswer8.length > 500)
                                        ? ""
                                        : ""
                                    }
                                    onChange={(e) => {
                                      setFeedbackAnswer8(e.target.value);
                                    }}
                                    onFocus={() => setIsFeedback8Interacted(true)}
                                  />
                                </div>
                              </Grid>
                              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
                                <MKButton variant="gradient" color="info" size="small" disabled={!feedbackRating || !feedbackAnswer1 || feedbackAnswer1.length < 10 || feedbackAnswer1.length > 500
                                  || !feedbackAnswer2 || feedbackAnswer2.length < 10 || feedbackAnswer2.length > 500
                                  || !feedbackAnswer3 || feedbackAnswer3.length < 10 || feedbackAnswer3.length > 500
                                  || !feedbackAnswer4 || feedbackAnswer4.length < 10 || feedbackAnswer4.length > 500
                                  || !feedbackAnswer5 || feedbackAnswer5.length < 10 || feedbackAnswer5.length > 500
                                  || !feedbackAnswer6 || feedbackAnswer6.length < 10 || feedbackAnswer6.length > 500
                                  || !feedbackAnswer7 || feedbackAnswer7.length < 10 || feedbackAnswer7.length > 500
                                  || !feedbackAnswer8 || feedbackAnswer8.length < 10 || feedbackAnswer8.length > 500}
                                  onClick={() => onSubmitFeebackClick(trainingDetails)} style={{ padding: '5px 10px' }}>Submit Feedback</MKButton>
                              </div>
                            </div>
                          </MKBox>
                        </Modal>
                      </div>
                    )}

                    {parseInt(trainingDetails.applyTrainingStatus) === 9 && (
                      <>
                        <Grid item>
                          <MKButton variant="gradient" color="info" size="small" onClick={() => onPaymentCompletedClick(trainingDetails)} style={{ padding: '5px 10px' }}>Paymemt Completed</MKButton>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Grid>
              </Container>

            </MKBox>
            {/* <Posts /> */}
          </Card>
          {/* <Contact /> */}
          {/* <Footer /> */}
          <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <MKBox position="center" zIndex={2} style={{ bottom: 0 }}>
              <SimpleFooter />
            </MKBox>
          </div>
        </MKBox>
      </LoadingOverlay>
    </>
  );
}

export default Author;
